import { c as _c } from "react/compiler-runtime";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "cn";
import type * as React from "react";

// ─── OptionCardGroup ──────────────────────────────────────────────────────────

interface OptionCardGroupProps extends React.ComponentProps<typeof RadioGroupPrimitive.Root> {
  layout?: "grid" | "stack";
}
function OptionCardGroup(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      layout: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const layout = t1 === undefined ? "stack" : t1;
  const t2 = layout === "grid" ? "grid grid-cols-1 gap-3 sm:grid-cols-2" : "flex flex-col gap-2";
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = cn(t2, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props || $[8] !== t3) {
    t4 = <RadioGroupPrimitive.Root data-slot="option-card-group" orientation="vertical" className={t3} {...props} />;
    $[7] = props;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

// ─── OptionCardItem ───────────────────────────────────────────────────────────

interface OptionCardItemProps extends React.ComponentProps<typeof RadioGroupPrimitive.Item> {
  label: React.ReactNode;
  icon?: React.ReactNode;
}
function OptionCardItem(t0) {
  const $ = _c(17);
  let className;
  let icon;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      label,
      icon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = icon;
    $[3] = label;
    $[4] = props;
  } else {
    className = $[1];
    icon = $[2];
    label = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("group flex w-full cursor-pointer items-center text-left", "rounded-md border border-border bg-card", "gap-3 p-3", "outline-none transition-colors", "hover:bg-muted", "data-[state=checked]:border-ring data-[state=checked]:bg-secondary", "focus-visible:ring-[3px] focus-visible:ring-ring/50", "disabled:pointer-events-none disabled:opacity-50", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== icon) {
    t2 = icon && <span aria-hidden={true} className={cn("flex size-10 shrink-0 items-center justify-center rounded-md transition-colors", "bg-muted text-foreground", "group-data-[state=checked]:bg-foreground group-data-[state=checked]:text-background", "[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-5 [&_svg]:shrink-0")}>{icon}</span>;
    $[7] = icon;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== label) {
    t3 = <span className="heading-sm flex-1 text-foreground">{label}</span>;
    $[9] = label;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <RadioGroupPrimitive.Indicator className="text-primary"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg></RadioGroupPrimitive.Indicator>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t5 = <RadioGroupPrimitive.Item data-slot="option-card-item" className={t1} {...props}>{t2}{t3}{t4}</RadioGroupPrimitive.Item>;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export { OptionCardGroup, OptionCardItem, type OptionCardGroupProps, type OptionCardItemProps };